import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "form": _vm.$refs.form,
      "buttons": _vm.dataSourceButtons
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c(VCardTitle, {
    staticClass: "px-1"
  }, [_c(VRow, {
    staticClass: "my-0 py-0",
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('h3', {
    class: `my-0 headline ${_vm.color}--text`
  }, [_vm._v("\n              " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('NiotaClassic.DataSources.form.titleUpdate') : _vm.$i18n_t('NiotaClassic.DataSources.form.titleCreate')) + "\n              " + _vm._s(_vm.formItem.id ? ` - ${_vm.formItem.source}` : '') + "\n            ")])]), _c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "cols": "2"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Common.form.active'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "hide-details": "auto"
    },
    model: {
      value: _vm.formItem.active,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "active", $$v);
      },
      expression: "formItem.active"
    }
  })], 1)], 1)], 1), _c(VDivider), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "justify": "center"
    }
  }, [_c('div', [_c('div', {
    staticClass: "image-upload-wrapper",
    on: {
      "click": function ($event) {
        return _vm.$refs.attachmentInput.click();
      }
    }
  }, [_c('img', {
    staticClass: "image-upload-img",
    attrs: {
      "src": _vm.formItem.image ? _vm.niota1ImageUrl(_vm.formItem.image) : 'img/niota-classic/placeholder.png'
    }
  }), _c('input', {
    ref: "attachmentInput",
    staticStyle: {
      "visibility": "hidden",
      "width": "0",
      "height": "0"
    },
    attrs: {
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": _vm.imageInputChanged
    }
  })])])]), _c(VCol, {
    attrs: {
      "cols": "8",
      "sm": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.DataSources.form.source'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.formItem.source,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "source", $$v);
      },
      expression: "formItem.source"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c(VSelect, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.DataSources.form.status'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "items": _vm.statusItems,
      "hide-details": "auto",
      "required": ""
    },
    model: {
      value: _vm.formItem.status,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "status", $$v);
      },
      expression: "formItem.status"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c(VSelect, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.DataSources.form.type'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "items": ['actility', 'auto_id', 'discovergy', 'filesystem', 'firefly', 'firefly_mqtt', 'sigfox', 'temetra', 'ttn', 'udp', 'webhook'],
      "hide-details": "auto",
      "required": ""
    },
    model: {
      value: _vm.formItem.type,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "type", $$v);
      },
      expression: "formItem.type"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "label": _vm.$i18n_t('Common.description'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "autofocus": false,
      "hide-details": "auto"
    },
    model: {
      value: _vm.formItem.description,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "description", $$v);
      },
      expression: "formItem.description"
    }
  })], 1), _vm.isFieldEnabled('server') ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DataSources.form.applicationAddress'),
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.formItem.server,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "server", $$v);
      },
      expression: "formItem.server"
    }
  })], 1) : _vm._e(), _vm.isFieldEnabled('server_rest') ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DataSources.form.restApiAddress'),
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.formItem.server_rest,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "server_rest", $$v);
      },
      expression: "formItem.server_rest"
    }
  })], 1) : _vm._e(), _vm.isFieldEnabled('server_mqtt') ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DataSources.form.mqttBrokerAddress'),
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.server_mqtt,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "server_mqtt", $$v);
      },
      expression: "formItem.server_mqtt"
    }
  })], 1) : _vm._e(), _vm.isFieldEnabled('tcpPort') ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DataSources.form.tcpPort'),
      "hide-details": "auto",
      "type": "number",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.tcpPort,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "tcpPort", $$v);
      },
      expression: "formItem.tcpPort"
    }
  })], 1) : _vm._e(), _vm.isFieldEnabled('udpPort') ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DataSources.form.udpPort'),
      "hide-details": "auto",
      "type": "number",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.udpPort,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "udpPort", $$v);
      },
      expression: "formItem.udpPort"
    }
  })], 1) : _vm._e(), _vm.isFieldEnabled('useTLS') ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DataSources.form.useTLS'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.formItem.useTLS,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "useTLS", $$v);
      },
      expression: "formItem.useTLS"
    }
  })], 1) : _vm._e(), _vm.isSuperSystemAdmin && _vm.isFirefly && _vm.formItem.properties ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DataSources.form.elasticsearchAddress'),
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.properties.elasticsearchAddress,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "elasticsearchAddress", $$v);
      },
      expression: "formItem.properties.elasticsearchAddress"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };